<template>
  <v-container fluid grid-list-md="grid-list-md">
    <Create :createDialog="createDialog" @close="close" @createdAdImage="createdAdImage"> </Create>
    <Edit :editDialog="editDialog" @close="closeEdit" @updatedAdImage="updatedAdImage" :adImage="adImage">
    </Edit>
    <v-card class="mt-2">
      <v-toolbar class="elevation-0" height="45" color="gray">
        <v-toolbar-title>
          <h1 class="subtitle-1">{{ $t("pageHeader.ads") }}</h1>
        </v-toolbar-title>
        <v-btn color="teal" dark="dark" small absolute="absolute" bottom="bottom" right fab="fab" @click="add">
          <v-icon>add</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-title>
        <v-flex xs12 md4>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line="single-line"
            hide-details>
          </v-text-field>
        </v-flex>
      </v-card-title>
      <v-data-table :headers="headers" item-key="id" :items="adImages" :search="search" :loading="loading"
        :pagination.sync="pagination">
        <template slot="items" slot-scope="props">
          <tr class="pointer">
            <td class="pa-2">
              <img :src="props.item.url" width="150" height="80" />
            </td>
            <td class="text-left">{{ props.item.companyName }}</td>
            <td class="text-left">{{ props.item.version }}</td>
            <td class="text-left small-td">{{ props.item.clickUrl }}</td>
            <td class="text-left small-td">{{ props.item.contactEmail }}</td>
            <td class="text-left">{{ props.item.ClickImageDetails.length }}</td>
            <td>
              <v-switch v-model="props.item.isActive" readonly="readonly"> </v-switch>
            </td>
            <td class="justify-end layout px-0">
              <v-menu bottom="bottom" left="left">
                <v-btn slot="activator" icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list class="menu-button">
                  <v-list-item @click="edit(props.item)">
                    <v-list-item-title>{{ $t("buttons.edit") }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="removeAdImage(props.item)">
                    <v-list-item-title>{{ $t("buttons.delete") }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">Your search for "{{ search }}" found no
          results.</v-alert>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import adImageService from "../service.js";
import Create from "./Create";
import Edit from "./Edit";

export default {
  data() {
    return {
      createDialog: false,
      adImage: null,
      editDialog: false,
      headers: [
        {
          text: this.$t("labels.image"),
          value: "url",
          sortable: true
        },
        {
          text: this.$t("labels.name"),
          value: "companyName",
          sortable: true
        },
        {
          text: this.$t("labels.version"),
          value: "version",
          sortable: true
        },
        {
          text: this.$t("labels.url"),
          value: "clickUrl",
          sortable: true
        },
        {
          text: this.$t("labels.email"),
          value: "contactEmail",
          sortable: true
        },
        {
          text: this.$t("labels.clickCount"),
          value: "contactEmail",
          sortable: true
        },
        {
          text: this.$t("labels.active"),
          value: "isActive",
          sortable: true
        },
        {
          text: "",
          value: "action",
          sortable: false
        }
      ],
      search: null,
      adImages: [],
      loading: true,
      pagination: {
        rowsPerPage: 10,
        sortBy: "id",
        descending: true
      }
    };
  },
  async created() {
    await this.resetList();
    await this.getAllListAds();
  },
  components: {
    Create,
    Edit
  },
  methods: {
    gotoPageNewTab(data) {
      // let routeData = this.$router.resolve({ path: `/adImage/profile/${data.id}`})
      // window.open(routeData.href, '_blank')
    },
    removeAdImage(adImage) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          this.$Progress.start();
          return adImageService
            .delete(adImage.id)
            .then(response => {
              if (response.data) {
                this.$swal("Deleted!", "AdImage has been deleted.", "success");
                this.$Progress.finish();
                this.getAllListAds();
              }
            })
            .catch(error => {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000
                })
                .fire({
                  type: "error",
                  title: err.data.message
                });
              this.$Progress.fail();
            });
        }
      });
    },
    add() {
      this.createDialog = true;
    },
    close() {
      this.createDialog = false;
    },
    closeEdit() {
      this.editDialog = false;
    },
    createdAdImage() {
      this.close();
      this.getAllListAds();
    },
    updatedAdImage() {
      this.closeEdit();
      this.getAllListAds();
    },
    edit(data) {
      this.adImage = data;
      this.editDialog = true;
    },
    updated() {
      this.editDialog = false;
      this.getAllListAds();
    },
    gotoPage(data) {
      // this.$router.push({ path: `/adImage/profile/${data.id}` })
    },
    reset() {
      this.resetList();
      this.getAllListAds();
    },
    resetList() { },
    reloadData() {
      this.loading = true;
      return adImageService.getAll().then(response => {
        this.adImages = response.data;
        this.loading = false;
        return response;
      });
    },
    getAllListAds() {
      this.loading = true;
      adImageService.getAllListAds().then(response => {
        this.adImages = response;
        this.loading = false;
      });
    }
  }
};
</script>
